import { useState } from "react";
import { useTranslation } from "react-i18next";

import { CircleIcon } from "../../icons/CircleIcon/CircleIcon";
import { MegaphoneIcon } from "../../icons/MegaphoneIcon/MegaphoneIcon";

import styles from "./multiselect.module.css";

type multiselectProps = {
  title?: string;
  options: { value: string; label: string }[];
  onSelect: (selectedOptions: string[]) => void;
  initialSelectedOptions?: string[];
  showAdmin?: boolean;
};

export const MultiselectRoles = ({
  title,
  options,
  onSelect,
  initialSelectedOptions = [],
  showAdmin = true,
}: multiselectProps) => {
  const { t } = useTranslation();
  const [selectedOptions, setSelectedOptions] = useState<string[]>(
    () =>
      initialSelectedOptions?.map(
        (property: any) => property?.value ?? property
      ) || []
  );

  const handleOptionClick = (option: any) => {
    setSelectedOptions((prevSelected: any) => {
      if (prevSelected.includes(option)) {
        const updatedSelection = prevSelected.filter(
          (item: any) => item !== option
        );
        onSelect(updatedSelection);
        return updatedSelection;
      } else {
        const updatedSelection = [...prevSelected, option];
        onSelect(updatedSelection);
        return updatedSelection;
      }
    });
  };

  return (
    <div className={styles["multiselect"]}>
      {title && (
        <div className={styles["multiselect__title"]}>
          <span>{title}</span>
          <MegaphoneIcon />
        </div>
      )}

      <div className={styles["multiselect__options"]}>
        {showAdmin && (
          <div
            style={{ opacity: "50%" }}
            className={styles["multiselect__option"]}
            onClick={() => {}}
          >
            <CircleIcon isSelected={true} />
            {t("Admin")}
          </div>
        )}
        {options.map((option, index) => (
          <div
            key={index}
            className={styles["multiselect__option"]}
            onClick={() => handleOptionClick(option.value)}
          >
            <CircleIcon isSelected={selectedOptions.includes(option.value)} />
            {option.label}
          </div>
        ))}
      </div>
    </div>
  );
};
